class LoyaltyLionPoints extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    console.log('loyalty lion points constructor');
  }

  connectedCallback() {
    this.cartTotal = parseInt(this.getAttribute('cart-total'));
    this.pointsContainer = this.querySelector('[data-lion-points-container]');
    this.setupObserver();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setupObserver() {
    if (!this.pointsContainer) return;

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          this.init();
        }
      });
    });

    this.observer.observe(this.pointsContainer, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  async init() {
    if (!this.isUSD()) {
      const convertedTotal = await this.convertToUSD(this.cartTotal);

      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }

      this.pointsContainer.textContent = convertedTotal;
    }
  }

  isUSD() {
    return window.Shopify.currency.active === 'USD';
  }

  async waitForGlbeApp() {
    return new Promise((resolve) => {
      if (typeof glbeApp !== 'undefined' && glbeApp) {
        resolve(glbeApp);
        return;
      }

      const checkInterval = setInterval(() => {
        if (typeof glbeApp !== 'undefined' && glbeApp) {
          clearInterval(checkInterval);
          resolve(glbeApp);
        }
      }, 100);
    });
  }

  async convertToUSD(total) {
    const app = await this.waitForGlbeApp();
    await app.modules.priceInfo.load();
    const gleRate = app.modules.priceInfo.convertPrice(1) || Shopify.currency.rate

    const convertedTotal = (total / gleRate) / 100;
    return this.formatPrice(convertedTotal);
  }

  formatPrice(price) {
    return price.toFixed(0);
  }
}

customElements.define('loyalty-lion-points', LoyaltyLionPoints)